import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const radiogroupClasses = tv({
  base: ["Radio__group flex", "items-start", "text-gray-900"],
  variants: {
    orientation: {
      horizontal: "flex-row gap-x-2",
      vertical: "flex-col gap-y-2",
    },
    variant: {
      default: "",
      options: "flex-col gap-y-4 w-full",
      card: "",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export type RadioGroupVariantProps = VariantProps<typeof radiogroupClasses>;
